import { Component, Input, OnInit } from "@angular/core";
import { RememberService } from "../../remember/remember.service";
import { UpgradeModalService } from "../../upgrade-modal/upgrade-modal.service";

type Callback = (frame: any) => boolean;

@Component({
  selector: "ab-backtrace",
  templateUrl: "./backtrace.component.html",
})
export class BacktraceComponent implements OnInit {
  @Input() public errors: any;
  @Input() public repoUrl: string;
  @Input() public rootDir: string;
  @Input() public gitRevision: string;
  @Input() public codeHunksEnabled: boolean;

  public showCodeHunks: any;
  public hasCodeHunks: boolean;
  public hasMinFiles: boolean;

  private rememberKey = "backtrace.showCodeHunks";

  constructor(
    private rememberService: RememberService,
    private upgradeModal: UpgradeModalService,
  ) {}

  public ngOnInit(): void {
    this.showCodeHunks =
      this.codeHunksEnabled && this.rememberService.get(this.rememberKey, true);
    this.hasCodeHunks = this.errorsContain(this.errors, (frame: any) => {
      return frame.code;
    });
    this.hasMinFiles = this.errorsContain(this.errors, (frame: any) => {
      if (!frame.file) {
        return false;
      }
      return frame.file.endsWith(".min.js") && frame.column > 0;
    });
  }

  public trackByIndex(index: number, _item: any) {
    return index;
  }

  public openUpgradeModal($event: any) {
    this.upgradeModal.open($event);
  }

  public toggleCodeHunks(): void {
    this.rememberService.set(this.rememberKey, this.showCodeHunks);
  }

  public errorTrackBy(index: number, _error: any) {
    return index;
  }
  public frameTrackBy(index: number, _error: any) {
    return index;
  }

  // Do not sort the object by defaultComparator. For more info about
  // defaultComparator please visit https://angular.io/api/common/KeyValuePipe.
  public orderBy(_a: any, _b: any) {
    return 0;
  }

  private backtraceContains(backtrace: any[], callback: Callback): boolean {
    if (backtrace == null) {
      return false;
    }

    for (const frame of backtrace) {
      if (callback(frame)) {
        return true;
      }
    }
    return false;
  }

  private errorsContain(errors: any[], callback: Callback): boolean {
    if (errors == null) {
      return false;
    }

    for (const error of errors) {
      if (this.backtraceContains(error.backtrace, callback)) {
        return true;
      }
    }
    return false;
  }
}
